import { render, staticRenderFns } from "./physician.vue?vue&type=template&id=07180412&scoped=true&"
import script from "./physician.vue?vue&type=script&lang=js&"
export * from "./physician.vue?vue&type=script&lang=js&"
import style0 from "./physician.vue?vue&type=style&index=0&id=07180412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07180412",
  null
  
)

export default component.exports